export default {"src":"https://assets.madeeasy.in/non-prod/_next/static/media/library_fill.b3019f17.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};